import { createFileRoute } from '@tanstack/react-router';
import { menuDetailQuery } from '@/api/queries/menus';
import { isFeatureUnlocked, sessionQuery } from '@/lib/session';
import { MenuEditorScreen, MenuRouteError } from '@/features/menus/MenuEditorScreen';

type BuilderSearch = { fresh?: boolean };

export const Route = createFileRoute('/_app/menus/$menuId/')({
  // `fresh`: just made by "New menu"; the builder selects the name, then
  // drops the flag from the address.
  validateSearch: (s: Record<string, unknown>): BuilderSearch => (s.fresh === true || s.fresh === 'true' || s.fresh === '1' ? { fresh: true } : {}),
  loader: async ({ context, params }) => {
    // A chef without Menus gets ComingSoon from the screen, not a 403 from
    // here dressed up as "Menu not found" (and no Menus API call at all).
    const session = await context.queryClient.ensureQueryData(sessionQuery);
    if (!isFeatureUnlocked(session, 'menus')) return;
    await context.queryClient.ensureQueryData(menuDetailQuery(Number(params.menuId)));
  },
  // "Menu not found" only for a 404; a failed load (bad wifi, a 503) says
  // so and offers another try.
  errorComponent: MenuRouteError,
  component: () => {
    const { menuId } = Route.useParams();
    const { fresh } = Route.useSearch();
    return <MenuEditorScreen menuId={Number(menuId)} fresh={Boolean(fresh)} />;
  },
});
